import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { DataTypeProvider, } from '@devexpress/dx-react-grid'

export default class GenderTypeProvider extends Component {
  render() {
    return(
      <DataTypeProvider
        for={this.props.for}
        formatterComponent={({ value }) => value === 'F' ? 'Female' : value === 'M' ? 'Male' : '' }
        editorComponent={({ column, row, value, onValueChange }) =>
          <Select
            value={value ? value : ""}
            displayEmpty
            autoWidth
            onChange={event => onValueChange(event.target.value)} >
            { row ? null : <MenuItem value={""}>Filter...</MenuItem> }
            <MenuItem value={"F"}>Female</MenuItem>
            <MenuItem value={"M"}>Male</MenuItem>
          </Select>
        }
      />
    );
  }
}

GenderTypeProvider.propTypes = {
  for: PropTypes.array.isRequired,
}
